export default "__VITE_ASSET__Ikujmp2O__"